const config = {
  apiUrl: process.env.REACT_APP_API_ENDPOINT,
  baseUrl: "",
  debounceTime: 500,
  links: {
    playstore: "#",
  },
  countryCodes: ["+91", "+256"],
  userTypes: [
    { value: 1, label: "Admin" },
    { value: 2, label: "User" },
  ],
  buyerTypes: [
    { value: 1, label: "B2B" },
    { value: 2, label: "B2C" },
    { value: 3, label: "B2G" },
  ],
  buyerCategory: [
    { value: 3, label: "Both" },
    { value: 1, label: "Buyer" },
    { value: 2, label: "Seller" },
  ],
  expenseCategories: [
    { value: 1, label: "Expense" },
    { value: 2, label: "Income" },
    { value: 3, label: "Withdraw" },
  ],
  dropdown1: [
    { value: 1, label: "drop1" },
    { value: 2, label: "down1" },
  ],
  dropdown2: [
    { value: 1, label: "drop2" },
    { value: 2, label: "down2" },
  ],
  dropdown3: [
    { value: 1, label: "drop3" },
    { value: 2, label: "down3" },
  ],
  stockInType: [
    { value: 101, label: "Import" },
    { value: 102, label: "Local" },
  ],
  purchaseType: [
    { value: "local", label: "Local" },
    { value: "import", label: "Import" },
  ],
  stockType: [
    { value: 1, label: "Consumption" },
    { value: 2, label: "Production" },
  ],
  creditNoteReasons: [
    { value: 101, label: "Amount Issue" },
    { value: 102, label: "Other Reason" },
  ],
  paymentMode: [
    { value: 1, label: "Cash" },
    { value: 2, label: "Credit" },
  ],
  filterStatus: [
    { value: "", label: "All" },
    { value: 1, label: "New" },
    { value: 2, label: "Partially Done" },
    { value: 3, label: "Freeze" },
    { value: 4, label: "Issued" },
    { value: 5, label: "Cancelled" },
    { value: 6, label: "Disputed" },
  ],
  filterPurchaseStatus: [
    { value: "", label: "All" },
    { value: 1, label: "Pending" },
    { value: 2, label: "Approved" },
    { value: 3, label: "Rejected" },
    { value: 4, label: "Partial" },
    { value: 5, label: "Cancelled" },
  ],
  filterPurchaseReturnStatus: [
    { value: "", label: "All" },
    { value: 1, label: "Pending" },
    { value: 2, label: "Approved" },
    { value: 3, label: "Rejected" },
    { value: 4, label: "Partial" },
    { value: 5, label: "Cancelled" },
  ],
  filterReturnStatus: [
    { value: "", label: "All" },
    { value: 1, label: "New" },
    { value: 2, label: "Partially Done" },
    { value: 3, label: "Freeze" },
    { value: 4, label: "Issued" },
    { value: 5, label: "Cancelled" },
  ],
  // paymentMode: [{ value: 1, label: "Cash" }, { value: 2, label: "Credit" }, { value: 3, label: "Stanbic Bank" }, { value: 4, label: "Centenary Bank" }, { value: 5, label: "DFCU Bank" }]
  challanPrintOptions: [
    {
      key: "_price_with_comp_name",
      label: "Price With Comp Name",
      compName: true,
    },
    {
      key: "_price_without_comp_name",
      label: "Price Without Comp Name",
      compName: false,
    },
    {
      key: "_no_price_with_comp_name",
      label: "No Price With Comp Name",
      compName: true,
    },
    {
      key: "_no_price_without_comp_name",
      label: "No Price Without Comp Name",
      compName: false,
    },
    {
      key: "_godown_wise_with_comp_name",
      label: "Gate Pass With Comp Name",
      compName: true,
    },
    {
      key: "_godown_wise_without_comp_name",
      label: "Gate Pass Without Comp Name",
      compName: false,
    },
  ],
};

export default config;

export const config2 = {
  apiUrl: process.env.REACT_APP_API_ENDPOINT2,
};
